import React, { useEffect } from "react";
import { useAppSelector, useAppDispatch } from "../../store/hooks";
import { fetchBranchById, clearBranch } from "../../store/slices/departmentSlice";
import { fetchBranches } from "../../store/slices/branchSlice";
import styles from "./DepartmentList.module.css";

export default function DepartmentList() {
  const dispatch = useAppDispatch();
  const { branches } = useAppSelector((state) => state.branch);
  const { branch, selectedBranchId, isLoading, error } = useAppSelector((state) => state.department);

  useEffect(() => {
    dispatch(fetchBranches());
  }, [dispatch]);

  const handleBranchSelect = (e) => {
    const branchId = e.target.value;
    if (branchId) {
      dispatch(fetchBranchById(branchId));
    } else {
      dispatch(clearBranch());
    }
  };

  if (!branches?.length) {
    return (
      <div className={styles.departmentList}>
        <h3 className={styles.title}>Departmanlar</h3>
        <p className={styles.empty}>Önce şube ekleyin veya şubeler yükleniyor.</p>
      </div>
    );
  }

  return (
    <div className={styles.departmentList}>
      <h3 className={styles.title}>Departmanlar</h3>
      <div className={styles.selectWrapper}>
        <label htmlFor="branch-select" className={styles.label}>
          Şube seçin
        </label>
        <select
          id="branch-select"
          className={styles.select}
          onChange={handleBranchSelect}
          value={selectedBranchId ?? branch?.id ?? ""}
        >
          <option value="">-- Şube seçin --</option>
          {branches.map((b) => (
            <option key={b.id} value={b.id}>
              {b.name}
            </option>
          ))}
        </select>
      </div>

      {isLoading && <div className={styles.loading}>Yükleniyor...</div>}
      {error && <div className={styles.error}>Hata: {error}</div>}

      {!isLoading && !error && branch && (
        <div className={styles.content}>
          <div className={styles.branchInfo}>
            <h4 className={styles.branchName}>{branch.name}</h4>
            {branch.institution && (
              <span className={styles.institution}>{branch.institution.name}</span>
            )}
          </div>
          {branch.departments?.length > 0 ? (
            <ul className={styles.list}>
              {branch.departments.map((dept) => (
                <li key={dept.id} className={styles.departmentItem}>
                  <div className={styles.departmentName}>{dept.name}</div>
                  {dept.description && (
                    <div className={styles.departmentDescription}>{dept.description}</div>
                  )}
                </li>
              ))}
            </ul>
          ) : (
            <p className={styles.empty}>Bu şubede departman bulunmuyor.</p>
          )}
        </div>
      )}

      {!isLoading && !error && !branch && (
        <p className={styles.hint}>Departmanları görmek için yukarıdan bir şube seçin.</p>
      )}
    </div>
  );
}
